// components/tabs/BrowseTab.js
import React, { useEffect, useState } from 'react';
import { API_URL, ENDPOINTS } from '../../../constants/api';
import { getToken } from '../../../utils/TokenUtils';
import axios from 'axios';
import '../css/BrowseTab.css';

function DbUpdates() {
  const [rows, setRows] = useState([]);
  const token = getToken();
  useEffect(() => {
    const browse = async () => {
      const response = await axios.get(
        `${API_URL}/${ENDPOINTS.SQL}/db-updates/`,
        {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        }
      );

      setRows(response.data.results);
    };
    browse();
  }, []);

  if (!rows.length) return <p>No data available.</p>;

  return (
    <div className="table-responsive">
      <h2>SQL Execution Results</h2>
      <table className="table table-bordered table-hover table-striped">
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>Status</th>
            <th>Query</th>
            <th>Result / Error</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((result) => (
            <tr key={result.queryNumber}>
              <td>{result.queryNumber}</td>
              <td>{result.success ? '✅ Success' : '❌ Error'}</td>
              <td>{result.query}</td>

              <td>
                {result.success ? (
                  <pre className="mb-0">
                    {JSON.stringify(result.res, null, 2)}
                  </pre>
                ) : (
                  <span className="text-danger">{result.error}</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DbUpdates;
